import { Box, ListItem, ListItemText, makeStyles } from "@material-ui/core";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { LegendBoxContentsName, LegendBoxList, LegendCssSquareIconListItem, LegendListDivider } from "../../legend/LegendBoxComponents";

const useStyles = makeStyles({
  listItem: {
    padding: 0,
    height: 17
  },
  listItemText: {
    paddingLeft: 7,
    margin: 0,
    position: "relative",
    top: 9,
    textAlign: "right",
    left: 3
  }
});

function LegendSst() {
  const {t} = useTranslation();
  const classes = useStyles();
  return (
    <>
      <Box sx={{display: 'flex', columnGap: 10, minWidth: 112}}>
        <div>
          <LegendBoxContentsName>{t('Sea Surface Temperature')} (°C)</LegendBoxContentsName>
          <Box sx={{display: 'flex'}}>
            <LegendBoxList>
              <ListItem className={classes.listItem}>
                <ListItemText className={classes.listItemText}>
                  40
                </ListItemText>
              </ListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(82, 0, 0, 0.8)'} text={<>35</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(167, 25, 25, 0.8)'} text={<>30</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(255, 0, 0, 0.8)'} text={<>25</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(253, 249, 13, 0.8)'} text={<>20</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(45, 138, 80, 0.8)'} text={<>15</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(22, 192, 228, 0.8)'} text={<>10</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(1, 60, 187, 0.8)'} text={<>5</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(90, 22, 251, 0.8)'} text={<>0</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(160, 32, 245, 0.8)'} text={<>-5</>}></LegendCssSquareIconListItem>
              <LegendListDivider />
              <LegendCssSquareIconListItem background={'rgba(184, 53, 142, 0.8)'} ></LegendCssSquareIconListItem>
            </LegendBoxList>
          </Box>
        </div>
      </Box>
    </>
  )
}

export default memo(LegendSst);
